import { Field } from 'redux-form';
import { TooltippedIcon } from '@mews-commander/ui';
import { CheckboxGroup, CheckboxGroupProps, IconName } from '@optimus-web/core';
import { getError } from '../../utils';

interface CheckboxGroupFieldRendererProps extends CheckboxGroupProps {
    input?: $TSFixMe; // TODO: pt.shape(fieldInputPropTypes from redux-form)
    meta?: $TSFixMe; // TODO: pt.shape(fieldMetaPropTypes from redux-form)
    helper?: $TSFixMe;
}

const CheckboxGroupFieldRenderer = ({
    input: { onChange, value },
    options,
    meta,
    helper,
    ...other
}: CheckboxGroupFieldRendererProps) => {
    const handleChange = (event: $TSFixMe, values: $TSFixMe) => {
        onChange(values);
    };

    const caption = helper ? <TooltippedIcon size="small" value={IconName.Info} tooltip={helper} /> : null;

    return (
        <CheckboxGroup
            options={options}
            values={value}
            error={getError(meta)}
            onChange={handleChange}
            captionIconWithTooltip={caption}
            {...other}
        />
    );
};

const CheckboxGroupField = (props: $TSFixMe) => <Field component={CheckboxGroupFieldRenderer} {...props} />;

export default CheckboxGroupField;
